import React from 'react'
//import PrimaryLabel from '../../../../components/label/primaryLabel'
import './ourMission.css'
export default function OurMission() {

    return (

        <div className='flex flex-row justify-between items-center w-[90%] gap-6 my-10 md:px-4'>
            <div className="flex flex-col basis-[50%]">
                <img
                    src={"../Assets/Banner/mission.png"}
                    alt="myprofile"
                    className="rounded-2xl mx-auto w-2/3"
                />
            </div>
            <div className='basis-[50%] mx-4 max-w-5xl flex flex-col justify-center overflow-hidden' data-aos="fade-left" data-aos-duration="1000" >
                <span className="font-pop text-lg px-3 py-1 mb-4 bg-white rounded-lg text-gray-700 mx-auto w-fit"> OUR MISSION</span>
                <h1 className='font-pop text-xl  md:text-3xl lg:text-4x my-4 font-semibold md:leading-normal'>At Paycott, we are committed to providing
                    a secure and efficient platform for buyers
                    and sellers to connect and do business.</h1>
                <div className='md:max-w-4xl text-sm md:text-lg font-pop text-lightGrey md:leading-relaxed'>
                    Our mission is to help people succeed by providing a reliable and easy-to-use platform
                    that facilitates the creation and acceptance of offers. We believe that by empowering people
                    to connect and do business, we can make the world a better place.
                </div>
            </div>
        </div>
    )
}
